import type { BifrostWeb } from '@seekrtech/bifrost-web'
import type { Result, UserInfo } from '../types'

export interface AuthServiceMethods {
  auth: () => Promise<Result<UserInfo, 'abort'>>
  bindLegacyUser: () => Promise<Result<null, 'abort'>>
}

export function createAuthService(bifrost: BifrostWeb): AuthServiceMethods {
  return bifrost
    .createProxyBuilder<AuthServiceMethods>('AuthService')
    .withDefaultOptions({ timeout: 31_536_000_000 })
    .build()
}
